import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BusyProvider } from 'app/service/busy.service';
import { UfficioService } from 'app/service/ufficio.service';
import { SalaService } from 'app/service/sala.service';
import { SelectItem } from 'primeng/primeng';
import { AppConstants } from '../core/app.constants';
import { AuthAccessProvider } from '../core/core.auth';
import { BaseComponent, Prenotazione, RicercaPrenotazioniRequest, UserContext, UserInfo } from '../core/core.component';
import { MessageProvider } from '../service/message.service';
import { UserService } from '../service/user.service';

declare var $: any;

@Component({
  selector: 'app-ufficio',
  templateUrl: './ufficio.component.html',
  styleUrls: ['./ufficio.component.css']
  
})
export class UfficioComponent extends BaseComponent implements OnInit 
{
  it: any = AppConstants.ITA_CALENDAR_CONF;
  userContext: UserContext;
  userInfo: UserInfo = new UserInfo();
  currentUser: string = null;
  
  displayPrenotazioni: string = "";
  displayPrenotazioniSala: string = "";
  displayPiantina: string = "active";
  displayRiepilogo: string = "";

  completed: boolean =  true;
  showFilter: boolean = false;

  // ricerca prnotazioni
  filtroDataDa: Date = new Date();
  filtroDataA: Date = new Date();
  usersSelected: SelectItem[] = [];
  allUsers: SelectItem[] = [];
  filteredUsers: SelectItem[] = [];

  prenotazioni: Prenotazione[] = [];

  sortField: string = null;
  sortAsc: boolean = false;

  currentPrenotazione: Prenotazione = null;
  showDeleteConfirmPopup: boolean = false;

  constructor(protected authAccess: AuthAccessProvider, 
    protected router: Router,
    protected messageProvider: MessageProvider,
    private userService: UserService,
    private ufficioService: UfficioService,
    private salaService: SalaService,    
    private datePipe: DatePipe,
    private busyProvider: BusyProvider)
  { 
      super(authAccess, router, messageProvider);
      this.messageProvider.clearAll();
      this.userContext = this.authAccess.getUserContext();
      this.currentUser = this.userContext.userId;
  }

  ngOnInit(){
    this.userContext = this.authAccess.getUserContext();

    if(this.userContext == null) {    
      this.authAccess.invalidate();
    } else {

      this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
        result => {
          this.userInfo = result;
          if (this.userInfo.managedUsers.length > 0 && this.userInfo.managedUsers.indexOf(this.userContext.userId) < 0) {
            this.userInfo.managedUsers.push(this.userContext.userId);
          }
        },
        error => {
          this.handleError(error);
        }
      );
      
      this.userService.getUsers(this.userContext.srmToken, false, false).subscribe(result => {
        if (result && result.users) {
          result.users.forEach(user => {
            this.allUsers.push({ label: user.fullname, value: user.id });
          })
        }
      });

      this.filtroDataA = this.calcFiltroDataDa(this.filtroDataDa, 5);

      this.reload();

      this.ufficioService.getRefreshEvent().subscribe(
        event => {
          this.reload();
        }
      );
    }
  }

  calcFiltroDataDa(startDate : Date, numDay : number) {
    var result = 0;
    var out = new Date();
    out.setTime(startDate.getTime());
    while (result < numDay)  {  
        var weekDay = out.getDay();
        if(weekDay != 0 && weekDay != 6)
            result++;
        if(result < numDay)
          out.setDate(out.getDate()+1); 
    }
    return out;
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  display(section: string) {
    this.displayPrenotazioni = '';
    this.displayPrenotazioniSala = '';
    this.displayPiantina = '';
    this.displayRiepilogo = '';
    if (section === 'prenotazioni') {
      this.displayPrenotazioni = 'active';
    } else if (section === 'prenotazioniSala') {
      this.displayPrenotazioniSala = 'active';
    } else if (section === 'piantina') {
      this.displayPiantina = 'active';
      this.salaService.fireRefreshProspectEvent();
      this.ufficioService.fireRefreshProspectEvent();
    } else if (section === 'riepilogo') {
      this.displayRiepilogo = 'active';
    }
  }

  reload() {
    let req = new RicercaPrenotazioniRequest();
    req.dataDa = this.filtroDataDa;
    req.dataA = this.filtroDataA;
    req.userIdsList = [];
    if (this.usersSelected) {
      this.usersSelected.forEach(user => {
        req.userIdsList.push(user.value);
      });
    }

    this.completed = false;
    this.ufficioService.ricercaPrenotazioni(this.userContext.srmToken, req).subscribe(
      res => {
        if (res && res.prenotazioni) {
          this.prenotazioni = res.prenotazioni;
          if (this.sortField) {
            this.sort(this.sortField, this.sortAsc);
          }
        }
        this.completed = true;
      },
      error => {
        this.completed = true;
        this.handleError(error);
      }
    );
  }

  openDeleteConfirm(prenotazione: Prenotazione) {
    this.currentPrenotazione = prenotazione;
    this.showDeleteConfirmPopup = true;
  }

  closeDeleteConfirm() {
    this.showDeleteConfirmPopup = false;
  }

  cancellaPrenotazione() {
    if (this.currentPrenotazione) {
      this.busyProvider.showBusyIndicator();
      this.ufficioService.liberaScrivania(this.userContext.srmToken, this.currentPrenotazione.idPrenotazione).subscribe(
        () => {
          this.busyProvider.hideBusyIndicator();
          this.messageProvider.notifyMessage("Prenotazione scrivania eliminata correttamente");
          this.currentPrenotazione = null;
          this.ufficioService.fireRefreshEvent();
        },
        error => {
          this.busyProvider.hideBusyIndicator();
          this.currentPrenotazione = null;
          this.handleError(error);
      });
    }
  }

  sort(field: string, directionAsc?: boolean) {
    let formatDate: string = "yyyyMMdd";
    if(field == this.sortField) {
        this.sortAsc = (directionAsc != null && typeof(directionAsc) != 'undefined') ? directionAsc : !this.sortAsc;
    } else {
        this.sortField = field;
    }
      
    if (this.prenotazioni) {
      this.prenotazioni.sort((p1, p2) => {
        if (this.sortField == "data") {
          let d1 = this.datePipe.transform(p1.data, formatDate);
          let d2 = this.datePipe.transform(p2.data, formatDate);
          if (d1 == d2) {
            return 0;
          }
          return this.sortAsc ? (d1 > d2 ? 1 : -1) : (d1 > d2 ? -1 : 1);
        }
      });
    }
  }

  filterUser(event) {
    this.filteredUsers = AppConstants.filterSuggestions(this.allUsers, event.query, item => [item.label]);
	}
}



// WEBPACK FOOTER //
// ./src/app/ufficio/ufficio.component.ts